
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system-iot-na-zamowienie",
      function () {
        return require("private-next-pages/system-iot-na-zamowienie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system-iot-na-zamowienie"])
      });
    }
  